import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ExternalCrewInfo } from 'src/app/models/ExternalCrewInfo';

@Component({
    selector: 'app-no-access',
    templateUrl: './no-access.component.html',
    styleUrls: ['./no-access.component.scss'],
    standalone: false
})
export class NoAccessComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public crew: ExternalCrewInfo) {}
}
